module.exports = __webpack_public_path__ + "static/media/cleany-cleaning.e06b75a0.jpg";